/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

export const LOAD_ADDRESS_QAS = 'mbp-checkout/MFE/LOAD_ADDRESS_QAS';
export const CLEAR_ADDRESS_QAS = 'mbp-checkout/MFE/CLEAR_ADDRESS_QAS';
export const LOAD_FORMAT_QAS = 'mbp-checkout/MFE/LOAD_FORMAT_QAS';
export const CLEAR_FORMAT_QAS = 'mbp-checkout/CLEAR_FORMAT_QAS';
export const GET_FORMAT_QAS = 'mbp-checkout/GET_FORMAT_QAS';
export const RESET_QAS_STATE = 'mbp-checkout/RESET_QAS_STATE';
export const FLAG_ON_SHOW_VALIDATED_QAS = 'mbp-checkout/FLAG_ON_SHOW_VALIDATED_QAS';
export const FLAG_OFF_SHOW_VALIDATED_QAS = 'mbp-checkout/FLAG_OFF_SHOW_VALIDATED_QAS';
export const FLAG_MFE_QAS_FAILED = 'mbp-checkout/FLAG_MFE_QAS_FAILED';
export const UNVERIFIED_FLOW_ACTIVE = 'mbp-checkout/MFE/UNVERIFIED_FLOW_ACTIVE';
